module.exports = __webpack_public_path__ + "static/img/11.807f947.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/11.png
// module id = F5aE
// module chunks = 5